import { defineStore } from "pinia";
import { User } from "../../models/User";

export const useUserStore = defineStore("userStore", {
  state: () => ({
    //TODO not use User object
    // const user = new User();
    // return { ...user };
    user: new User(),
  }),
  actions: {
    login(obj: User) {
      this.user = { ...obj };
    },
    logout() {
      this.user = { ...new User() };
      localStorage.removeItem("token");
      return;
    },
  },
  persist: true,
});
